import CorporateCareTypeSelection from '@/apps/corporateOnboarding/careType/CorporateCareTypeSelection.vue';
import BackupCareRequest from '@/apps/corporateOnboarding/backupCare/BackupCareRequest.vue';
import { requireSeeker } from '../guards/authGuards';
import corporateOnboardingGuard from '../guards/corporateOnboardingGuard';
import combineGuards from '../guards/helpers';

const corporateOnboardingGuards = combineGuards([requireSeeker, corporateOnboardingGuard]);

/**
 * Corporate Onboarding Routes
 *
 * Entry at /corporate-onboarding resolves to either care type selection or backup care continuation.
 */
const corporateOnboardingRoutes = [
  {
    path: '/corporate-onboarding',
    name: 'corporate_onboarding',
    beforeEnter: corporateOnboardingGuards,
    redirect: '/corporate-onboarding/care-type',
  },
  {
    path: '/corporate-onboarding/care-type',
    name: 'corporate_onboarding_care_type',
    component: CorporateCareTypeSelection,
    meta: { simpleHeader: true },
    beforeEnter: corporateOnboardingGuards,
  },
  {
    path: '/corporate-onboarding/backup-care',
    name: 'corporate_onboarding_backup_care',
    component: BackupCareRequest,
    meta: { simpleHeader: true },
    beforeEnter: corporateOnboardingGuards,
  },
];

export default corporateOnboardingRoutes;
